import '../scss/app.scss';

import './accordion';
import './tabs';
import './newsletter';

const $ = jQuery;

$(document).ready(function() {
	$('.full-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
	});

	$('.full-slider-mobile').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
	});

    var maxHeight = 0;
    $('.timeline-item').each(function() {
        maxHeight = Math.max($(this).height(), maxHeight);
    });
    $('.timeline-item').height(maxHeight);

	// Initialize FitVids
	$('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids();

	$('.gallery-item a').featherlightGallery({
		variant: 'nf-gallery',
	});
});

// Navigation
$(document).ready(function() {
  var menuToggle = $("#js-mobile-menu").unbind();
  $("#js-navigation-menu").removeClass("show");

  menuToggle.on("click", function(e) {
    e.preventDefault();
    $("#js-navigation-menu").slideToggle(function() {
      if($("#js-navigation-menu").is(":hidden")) {
        $("#js-navigation-menu").removeAttr("style");
      }
    });
  });
});

// Sliding panel
$(document).ready(function() {
  $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart',function (e) {
    $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
    e.preventDefault();
  });
});



// WEBPACK FOOTER //
// ./src/js/app.js